export const ADMIN = () => 'admin';
export const INST = () => 'établissement';
export const ASKER = () => 'entreprise';
export const SUBINST = () => 'staff';
